import {Dispatch, SetStateAction} from "react";
import {ChevronDown as SortUp, ChevronUp as SortDown} from 'react-bootstrap-icons';
import {SortDirection} from "../api/admin/generated";

interface SortIconProps {
    sortDirection : SortDirection,
    setSortDirection?: Dispatch<SetStateAction<SortDirection>>;
}

export const SortIcon = ({sortDirection, setSortDirection} : SortIconProps) =>
{
    function toggleSort()
    {
        if (setSortDirection !== undefined) {
            setSortDirection(sortDirection === SortDirection.Asc ? SortDirection.Desc : SortDirection.Asc);
        }
    }

    return (
        <span className="sort-icon btn btn-link p-0 align-bottom" >
            {sortDirection === SortDirection.Asc ? <SortUp className="align-middle" onClick={toggleSort} title="Toggle sort"/> : <SortDown className="align-middle" onClick={toggleSort} title="Toggle sort"/>}
        </span>
    )
}
